import React from 'react';
import { string, shape } from 'prop-types';
import { Video } from '@fiverr-private/orca';
import { getSubtitles } from './services/subtitle';
import { VIDEO_TYPE } from './constants';

const ModalBody = ({ video, sourceInfo }) => {
    const {
        id,
        src
    } = video;

    const sources = [{
        src,
        type: VIDEO_TYPE
    }];

    const subtitles = getSubtitles(id);

    return (
        <Video width="100%"
            height="100%"
            controls
            autoPlay
            source={sources}
            subtitles={subtitles}
            sourceInfo={sourceInfo}/>
    );
};

ModalBody.propTypes = {
    video: shape({
        id: string,
        name: string,
        src: string
    }),
    sourceInfo: shape({
        videoName: string,
        mixpanel: shape({
            pageName: string
        }),
        bigQuery: shape({
            pageName: string
        })
    })
};

export default ModalBody;
